import { Box } from "@mui/system"
import CircularIndeterminate from "components/blocks/progressBar/progressBar"
import Headline3 from "components/elements/Headline3"
import ButtonMedium1 from "components/elements/ButtonMedium1"
import ContentNormal from "components/elements/ContentNormal"
import Headline2 from "components/elements/Headline2"
import SectionWrapper from "components/layouts/SectionWrapper"
import { AppContext } from "contexts/AppContext"
import React, { useContext, useEffect, useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { callAPI } from "utils/API"

export const PaymentError = () => {
    const navigate = useNavigate()
    const { styleGuide } = useContext(AppContext)
    const { ChargeID } = useParams();
    const [relatedType, setRelatedType] = useState(null)

    const handlePaymentSession = async () => {
        const handlePaymentResponse = await callAPI(`/charge/${ChargeID}/status`, "GET");
        if (handlePaymentResponse) {
            switch (handlePaymentResponse.relatedType) {
                case "CONFIRMATION":
                    setRelatedType("CONFIRMATION")
                    break;
                case "CONFIRMATION_DELIVERY":
                    setRelatedType("CONFIRMATION_DELIVERY")
                    break;
                case "WALLET":
                    setRelatedType("WALLET")
                    break;
                default:
                    setRelatedType("UNKNOWN")
                    break;
            }
        }
    }

    useEffect(() => {
        handlePaymentSession()
    }, [ChargeID])

    if (!relatedType) {
        return (
            <SectionWrapper sx={{ minHeight: '60vh' }}>
                <Box sx={{ paddingTop: 14 }} display={'flex'} flexDirection={'column'} gap={4} alignItems={'center'}>
                    <Box display={'flex'} gap={4}>
                        <Headline3
                            translationKey="_PAYMENT_PENDING_TITLE_"
                            fallbackText="Tak for dit køb"
                        />
                    </Box>
                    <ContentNormal
                        translationKey="_PAYMENT_PENDING_DESCRIPTION_"
                        fallbackText="Afventer bekræftelse på betaling..."
                    />

                    <CircularIndeterminate />
                </Box>
            </SectionWrapper>
        )
    }

    return (
        <SectionWrapper sx={{minHeight: '60vh'}}>
            <Box sx={{paddingTop: 14}} display={'flex'} flexDirection={'column'} gap={4}>
                <Box display={'flex'} gap={4}>
                    <Headline2
                        translationKey="_PAYMENT_ERROR_"
                        fallbackText="Fejl under betaling"
                        style={{color: styleGuide.color12}}
                    />
                </Box>
                {relatedType === "CONFIRMATION" && (
                    <Box display={'flex'} flexDirection={'column'} gap={4}>
                        <ContentNormal
                            translationKey="_PAYMENT_ERROR_DESCRIPTION_CONFIRMATION_"
                            fallbackText="Der opstod en fejl under betalingen af din ordre. Du kan gå tilbage til kurven og prøve igen."
                        />
                        <Box>
                            <ButtonMedium1
                                showIcon={false}
                                translationKey="_GO_TO_BASKET_"
                                fallbackText="Gå til kurven"
                                onClick={() => navigate("/basket")}
                            />
                        </Box>
                    </Box>
                )}
                {relatedType === "CONFIRMATION_DELIVERY" && (
                    <Box display={'flex'} flexDirection={'column'} gap={4}>
                        <ContentNormal
                            translationKey="_PAYMENT_ERROR_DESCRIPTION_CONFIRMATION_DELIVERY_"
                            fallbackText="Din ordre er gået igennem, men der opstod en fejl under betalingen af leveringsomkostningerne. Du kan finde din ordre under din profil og gå til betaling af levering igen. Ordren vil ikke blive håndteret før leveringen er betalt."
                        />
                        <Box>
                            <ButtonMedium1
                                showIcon={false}
                                translationKey="_GO_TO_ORDERS_"
                                fallbackText="Gå til dine ordrer"
                                onClick={() => navigate("/profile/orders")}
                            />
                        </Box>
                    </Box>
                )}
                {relatedType === "WALLET" && (
                    <Box display={'flex'} flexDirection={'column'} gap={4}>
                        <ContentNormal
                            translationKey="_PAYMENT_ERROR_DESCRIPTION_WALLET_"
                            fallbackText="Der opstod en fejl under betalingen af dine point. Du kan gå til din profil eller kurven for at prøve igen."
                        />
                        <Box>
                            <ButtonMedium1
                                showIcon={false}
                                translationKey="_GO_TO_BASKET_"
                                fallbackText="Gå til kurven"
                                onClick={() => navigate("/basket")}
                            />
                        </Box>
                    </Box>
                )}
                {relatedType === "UNKNOWN" && (
                    <Box display={'flex'} flexDirection={'column'} gap={4}>
                        <ContentNormal
                            translationKey="_PAYMENT_ERROR_DESCRIPTION_"
                            fallbackText="Der opstod en fejl under betalingen. Du kan gå tilbage til kurven og prøve igen."
                        />
                        <Box>
                            <ButtonMedium1
                                showIcon={false}
                                translationKey="_GO_TO_BASKET_"
                                fallbackText="Gå til kurven"
                                onClick={() => navigate("/basket")}
                            />
                        </Box>
                    </Box>
                )}
            </Box>
        </SectionWrapper>
    )
}

